import { Skeleton } from "@/components/ui/skeleton";
import { StatusBadge } from "@/components/ui/status-badge";
import { NvpStatusDot } from "@/components/nvp-status-dot";
import { TeamFlag } from "@/components/team-flag";
import type { NvpStatus } from "@/components/nvp-status-dot";
import type { components } from "@/api/generated/schema";

type Build = components["schemas"]["BuildResponse"];

interface BuildHeaderProps {
  build: Build | undefined;
  isLoading: boolean;
  nvpStatus: NvpStatus;
}

const STATUS_VARIANTS: Record<NvpStatus, "success" | "error" | "neutral"> = {
  online: "success",
  offline: "error",
  unknown: "neutral",
};

export function BuildHeader({ build, isLoading, nvpStatus }: BuildHeaderProps) {
  if (isLoading) {
    return <Skeleton className="h-8 w-64 rounded-lg" />;
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
      <h1 className="text-lg font-semibold tracking-tight inline-flex items-center gap-2">
        {build?.team_iso_alpha2 && <TeamFlag iso_alpha2={build.team_iso_alpha2} name={build.team_name ?? undefined} size="sm" />}
        {build?.team_name ?? `Build ${build?.id.slice(0, 8)}`}
        {build?.boat_number && (
          <span className="text-sm font-normal text-muted-foreground ml-1">
            · {build.boat_number}
          </span>
        )}
      </h1>
      <StatusBadge
        variant={STATUS_VARIANTS[nvpStatus]}
        icon={<NvpStatusDot status={nvpStatus} />}
      >
        {nvpStatus === "online" ? "Online" : nvpStatus === "offline" ? "Offline" : "Unknown"}
      </StatusBadge>
    </div>
  );
}
